export default "__VITE_ASSET__be683b97__"